module.exports = __webpack_public_path__ + "static/media/icon-thumb@2x.b3eaa73e.png";